


import React, { useState } from 'react';

const CrigotManufacturiingPage = () => {
  const [flippedTop, setFlippedTop] = useState(false);
  const [flippedRight, setFlippedRight] = useState(false);
  const [flippedBottom, setFlippedBottom] = useState(false);
  const [flippedLeft, setFlippedLeft] = useState(false);

  const handleClickTop = () => setFlippedTop(!flippedTop);
  const handleClickRight = () => setFlippedRight(!flippedRight);
  const handleClickBottom = () => setFlippedBottom(!flippedBottom);
  const handleClickLeft = () => setFlippedLeft(!flippedLeft);

  return (
    <div style={{ marginTop: '100px', marginBottom:'100px' }} className='crogot-pagedata'>
      <h1 style={{ color: 'rgb(236 115 34)', textAlign: 'center', marginBottom: "0px" }}>

        CRIGOT Framework
        <span style={{ color: '#000', marginLeft: "10px" }}>
          Offering  </span>
      </h1>
      <section className="circle-section">
        <h1
          style={{
            width: '120px',
            height: '120px',
            backgroundColor: 'rgb(236 115 34)', // Background color
            color: '#fff', // Text color
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '50%', // Makes it circular
            textAlign: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
            boxShadow: '0 4px 8px rgba(245, 99, 15, 0.2)', // Optional shadow
            border: '2px solid white'
          }}
        >
          CRIGOT
        </h1>


        <div className="circle-animation-container">
          <div className="circle-animation">
            {/* Your Lottie animation code here */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1000 1000"
              preserveAspectRatio="xMidYMid meet"
            >
              <defs>
                <clipPath id="__lottie_element_2">
                  <rect width="1000" height="1000" x="0" y="0"></rect>
                </clipPath>
                <linearGradient
                  id="__lottie_element_6"
                  spreadMethod="pad"
                  gradientUnits="userSpaceOnUse"
                  x1="-180.18899536132812"
                  y1="0"
                  x2="182.0749969482422"
                  y2="0.9430000185966492"
                >
                  <stop offset="0%" stopColor="rgb(248,177,81)"></stop>
                  <stop offset="50%" stopColor="rgb(255,164,36)"></stop>
                  <stop offset="100%" stopColor="rgb(255,149,0)"></stop>
                </linearGradient>
                <linearGradient
                  id="__lottie_element_10"
                  spreadMethod="pad"
                  gradientUnits="userSpaceOnUse"
                  x1="-90.09782409667969"
                  y1="158.88905334472656"
                  x2="0"
                  y2="0"
                >
                  <stop offset="0%" stopColor="rgb(255,255,255)"></stop>
                  <stop offset="25%" stopColor="rgb(255,215,163)"></stop>
                  <stop offset="50%" stopColor="rgb(255,175,71)"></stop>
                  <stop offset="75%" stopColor="rgb(250,167,49)"></stop>
                  <stop offset="100%" stopColor="rgb(255,149,0)"></stop>
                </linearGradient>
              </defs>
              <g clipPath="url(#__lottie_element_2)">
                <g
                  transform="matrix(2.119999885559082,0,0,2.119999885559082,108.86001586914062,108.86001586914062)"
                  opacity="1"
                >
                  <g opacity="1" transform="matrix(1,0,0,1,184.5,184.5)">
                    <path
                      stroke="url(#__lottie_element_10)"
                      strokeLinecap="round"
                      strokeLinejoin="miter"
                      fillOpacity="0"
                      strokeMiterlimit="10"
                      strokeOpacity="1"
                      strokeWidth="2"
                      d=" M182,0 C182,100.51599884033203 100.51599884033203,182 0,182 C-100.51599884033203,182 -182,100.51599884033203 -182,0 C-182,-100.51599884033203 -100.51599884033203,-182 0,-182 C100.51599884033203,-182 182,-100.51599884033203 182,0z"
                    ></path>
                  </g>
                </g>
                <g
                  transform="matrix(2.119999885559082,0,0,2.119999885559082,34.177032470703125,34.781036376953125)"
                  opacity="1"
                >
                  <g opacity="1" transform="matrix(1,0,0,1,219.5,219.5)">
                    <path
                      stroke="url(#__lottie_element_6)"
                      strokeLinecap="round"
                      strokeLinejoin="miter"
                      fillOpacity="0"
                      strokeMiterlimit="10"
                      strokeOpacity="1"
                      strokeWidth="15"
                      d=" M-33.775001525878906,178.8719940185547 C-72.32499694824219,171.63800048828125 -106.58999633789062,152.24899291992188 -132.43800354003906,124.83699798583984"
                    ></path>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>

        <div className="cards-container">
       


 <div
            className="card top"
            style={{ maxHeight: '150px', border: '1px solid rgb(236 115 34)' }}
            >
            <div className={`card-inner ${flippedRight ? 'flipped' : ''}`}>
              <div className="card-front">
              <p style={{ marginRight: "35px", color: 'rgb(236 115 34)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                  C<span style={{ color: "#fff" }}>ontrols </span>
                </p>
                <p style={{ marginTop: '10px',  color: '#fff' }}>
                Establishing Overarching Controls - "Building a fortress of compliance for industrial excellence."
                
                </p>
                <br />
              </div>
              <div className="card-back">
              <p style={{ color: "#fff", fontSize: "15px" }}>
              We design a comprehensive control framework tailored to manufacturing-specific regulations such as SCADA security, OT resilience, and critical infrastructure protection, ensuring your operations are safeguarded against cyber and compliance risks.
                
                </p>
              </div>
            </div>

           
          </div>





          <div
            className="card right"
            style={{ maxHeight: '150px', border: '1px solid rgb(236 115 34)' }}
            >
            <div className={`card-inner ${flippedRight ? 'flipped' : ''}`}>
              <div className="card-front">
                <p style={{ marginRight: "0px", color: 'rgb(236 115 34)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                  R<span style={{ color: "#fff" }}>isk & <span style={{ color: 'rgb(236 115 34)', }}>I</span>mpact</span>
                </p>
                <p style={{ marginTop: '10px', color: '#fff' }}>
                "Risk & Impact Assessment "Transforming vulnerabilities into actionable insights."
                
                </p>
                <br />
              </div>
              <div className="card-back">
                <p style={{ color: "#fff", fontSize: "15px" }}>
                Through in-depth risk and impact assessments, we identify weaknesses in IT and OT environments, evaluate compliance gaps, and prioritize risks that could compromise safety, security, and operational integrity in the manufacturing lifecycle.
               
                </p>
              </div>
            </div>

            <style jsx>{`
    .top::-webkit-scrollbar {
      width: 1px; /* Decrease scrollbar width */
    }

    .top::-webkit-scrollbar-thumb {
      background-color: rgba(255, 149, 0, 0.7); /* Optional: style the scrollbar thumb */
      border-radius: 10px;
    }

    .card-inner {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d; /* Ensure 3D effect */
      transition: transform 0.8s; /* Smooth flip effect */
    }

    .card-inner:hover {
      transform: rotateY(180deg); /* Flip the card on hover */
    }

    .card-front, .card-back {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backface-visibility: hidden; /* Hide back side when flipped */
      padding: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .card-front {
      color: #000;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
    }

    .card-back {
      color: #000;
      transform: rotateY(180deg); /* Initially rotate the back side */
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1; /* Ensure the back stays behind when flipped */
    }
  `}</style>
          </div>



          <div
            className="card bottom"
            style={{ maxHeight: '150px', border: '1px solid rgb(236 115 34)' }}
            onClick={handleClickBottom}
          >
            <div className={`card-inner ${flippedBottom ? 'flipped' : ''}`}>
              <div className="card-front">
                <p style={{ marginRight: "0px", color: 'rgb(236 115 34)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>Go<span style={{ color: "#fff" }}>vernance</span></p>
                <p style={{ marginTop: '10px',  color: '#fff' }}>
                "Governance & Remediation - "From compliance gaps to governance leadership."
                
                </p>
                <br />

              </div>
              <div className="card-back">
                <p style={{ color: "#fff", fontSize: "15px" }}>
                We remediate deficient controls, implement custom policies, and develop risk-control matrices, ensuring robust governance over critical systems such as SCADA, ICS, and IIoT while strengthening alignment with global regulatory requirements.
                
                </p>
              </div>
            </div>

         
          </div>
       

          <div
            className="card left"
            style={{ maxHeight: '150px', border: '1px solid rgb(236 115 34)' }}
            onClick={handleClickLeft}
          >
            <div className={`card-inner ${flippedLeft ? 'flipped' : ''}`}>
              <div className="card-front">
                <p style={{ marginRight: "35px", color: 'rgb(236 115 34)', fontSize: '30px', fontWeight: 'bold', marginTop: '10px' }}>
                  T<span style={{ color: "#fff" }}>ransformation</span>
                </p>
                <p style={{ marginTop: '10px',color: '#fff' }}>
                "Transformation - "Pioneering the future of secure, resilient manufacturing ecosystems."
               
                </p>
                <br />

              </div>
              <div className="card-back">
                <p style={{ color: "#fff", fontSize: "15px" }}>
                We enable long-term transformation by embedding AI-powered risk intelligence, real-time OT monitoring, and advanced cybersecurity frameworks, empowering manufacturers to thrive in an interconnected, data-driven, and highly regulated global marketplace.
              
                </p>
              </div>
            </div>

           
          </div>



        </div>

        <style jsx>{`
        .circle-section {
          position: relative;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .circle-animation-container {
          position: absolute;
          width: 650px; /* Increased width of the circle */
          height: 650px; /* Increased height of the circle */
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 0; /* Ensure it stays above the cards */
          animation: rotateCircle 10s infinite linear; /* Apply rotation animation */
        }

        @keyframes rotateCircle {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .circle-animation {
          width: 100%;
          height: 100%;
        }

        .cards-container {
          position: absolute;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          z-index: 1;
          width: 100%;
          height: 100%;
        }

        .card {
          padding: 10px;
          margin: 5px;
          width: 370px;
          height: 150px;
          text-align: center;
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          position: absolute;
          transition: box-shadow 0.3s ease; /* Smooth transition for box shadow */
          border: 1px solid #fe9900 ;
          background:#393838;
        }

        .card:hover {
          box-shadow: 0 4px 12px rgba(255, 149, 0, 0.7); /* Change box shadow color on hover */
        }

        .top {
          top: 0%; /* Positioned outside the top of the circle */
          left: 50%;
          transform: translateX(-50%);
          height: 170px;
        }

        .right {
          right: 11%; /* Positioned outside the right of the circle */
          top: 50%;
          transform: translateY(-50%);
              height: 170px;
        }

        .bottom {
          bottom: 0%; /* Positioned outside the bottom of the circle */
          left: 50%;
          transform: translateX(-50%);
              height: 170px;
        }

        .left {
          left: 11%; /* Positioned outside the left of the circle */
          top: 50%;
          transform: translateY(-50%);
              height: 170px;
        }
              /* Media Query for smaller screens */
 @media (max-width: 1400px) {
    .left {
        left: 7% !important; /* Adjust position on smaller screens */
      
    }
        .bottom {
          bottom: 0% !important; /* Positioned outside the bottom of the circle */
      
        }
          
        .right {
          right: 7%; /* Positioned outside the right of the circle */
         
        }
            .top {
          top: 0% !important; /* Positioned outside the top of the circle */
         
        }
 }
        @media (min-width: 1500px) {
   
        .bottom {
          bottom: 6.5% ; /* Positioned outside the bottom of the circle */
      
        }
 
            .top {
          top: 6.5% ; /* Positioned outside the top of the circle */
         
        }
      

       
 }

  @media (min-width: 1550px) {  
     .right {
          right: 13%; /* Positioned outside the right of the circle */
         
        }
           .left {
        left: 13% ; /* Adjust position on smaller screens */
      
    }
        }
          @media (min-width: 1650px) {  

  .right {
          right: 18%; /* Positioned outside the right of the circle */
         
        }
           .left {
        left: 18% !important; /* Adjust position on smaller screens */
      
    }
            .bottom {
          bottom: 15% ; /* Positioned outside the bottom of the circle */
      
        }
 
            .top {
          top: 15% ; /* Positioned outside the top of the circle */
         
        }

        }


      `}</style>
      </section>
    </div>
  );
};

export default CrigotManufacturiingPage;


